// extracted by mini-css-extract-plugin
module.exports = {"paginator":"Paginator_paginator__3j5OD","active":"Paginator_active__2WK2K","paginatorItems":"Paginator_paginatorItems__SPC1t"};